<!-- eslint-disable max-len -->
<template>
  <div class="wrap-content-mobile">
    <div class="header-view">
      <i
        class="fa fa-bars"
        @click="toggleSidebar"
      />
      <div class="title-app">{{ application_detail.name }}</div>
    </div>

    <!-- Sidebar App -->
    <div
      v-if="isShowSidebar"
      id="bg-blur-sidebar"
      class="bg-blur-sidebar"
      @click="toggleSidebar"
    />
    <div
      v-if="isShowSidebar"
      id="sidebar-mobile"
      class="sidebar-mobile"
    >
      <!-- Left Sidebar -->
      <div class="left-sidebar">
        <img
          src="@/assets/app-manager/icon/more-app.svg"
          width="25"
          height="25"
        >
        <div class="d-flex flex-column align-items-center">
          <div class="dummy-notification">
            <i class="fa fa-bell bell-icon" />
            <div class="dot-notification" />
          </div>
          <img
            :src="profile_data.photo_url || require('@/assets/img/profile-dummy.png')"
            class="profile-pic"
          >
        </div>
      </div>

      <!-- List Page -->
      <div class="wrap-page">
        <div class="d-flex flex-column align-items-center">
          <img
            :src="application_detail.icon"
            class="app-icon"
          >
          <div class="app-name">{{ application_detail.name }}</div>
        </div>

        <ul>
          <li
            v-for="page in listPages"
            :key="page.id"
          >
            <div
              :class="{'active': pageSelected && pageSelected.id === page.id}"
              class="page"
              @click="$emit('selected-page', page)"
            >
              <div class="d-flex align-items-start">
                <img
                  :src="pageSelected && pageSelected.id === page.id ? page.icon_active : page.icon_white"
                  class="page-icon"
                >
                <div class="page-name">{{ page.name }}</div>
              </div>

              <i
                v-if="page.child && page.type === 'menu'"
                class="fa fa-chevron-down dropdown-icon"
              />
            </div>

            <!-- Child Page -->
            <ul v-if="page.child.length > 0">
              <li
                v-for="child in page.child"
                :key="child.id"
              >
                <div
                  :class="{'active': pageSelected && pageSelected.id === child.id}"
                  class="page page-child"
                  @click="$emit('selected-page', child)"
                >
                  <div class="d-flex align-items-start">
                    <img
                      :src="pageSelected && pageSelected.id === child.id ? child.icon_active : child.icon_white"
                      class="page-icon"
                    >
                    <div class="page-name">{{ child.name }}</div>
                  </div>
                </div>
              </li>
            </ul>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    listPages: {
      type: Array,
      default: () => [],
    },
    pageSelected: {
      type: Object,
      default: () => null,
    },
  },

  data() {
    return {
      isShowSidebar: false,
    };
  },

  computed: {
    ...mapState('jStoreSetting', ['application_detail']),
    ...mapState('jStoreLogin', ['profile_data']),
  },

  methods: {
    toggleSidebar() {
      if (!this.isShowSidebar) {
        this.isShowSidebar = true;
        setTimeout(() => {
          document.getElementById('bg-blur-sidebar').classList.add('show');
        }, 50);
        setTimeout(() => {
          document.getElementById('sidebar-mobile').classList.add('show');
        }, 100);
      } else {
        document.getElementById('bg-blur-sidebar').classList.remove('show');
        document.getElementById('sidebar-mobile').classList.remove('show');
        setTimeout(() => {
          this.isShowSidebar = false;
        }, 200);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/application-manager/detail/app-tabs/partials/jLayoutTabMobile.vue